import React, { FC, useEffect } from 'react'

import { useLocation } from 'react-router-dom'

import { getSpecialHomePage } from '@/actions/actions'
import { PageContent } from '@/components/PageContent/PageContent'
import { pageTypes } from '@/constants/common'
import { TabsPage } from '@/containers/TabsPage/TabsPage'
import useStore from '@/store/useStore'

export const SpecialHomePage: FC = () => {
  const { search } = useLocation()
  const { page, setPage } = useStore((state) => state.page)
  const isTabPage = page?.pageType === pageTypes.TABS

  useEffect(() => {
    const controller = new AbortController()
    void getSpecialHomePage(controller.signal, search)
    return () => {
      setPage(null)
      controller.abort()
    }
  }, [])

  return isTabPage ? <TabsPage /> : <PageContent />
}
